$(document).ready(function() {


// Получаем нужный элемент
  var karaoke = document.querySelector('#karaoke');
  var interactive = document.querySelector('#interactive');
  var match = document.querySelector('#match');
  var clicker = document.querySelector('#clicker');
  var elemVisible

  var Visible = function (target) {
    var targetPosition = {
          top: window.pageYOffset + target.getBoundingClientRect().top,
          bottom: window.pageYOffset + target.getBoundingClientRect().bottom
        },
        windowPosition = {
          top: window.pageYOffset,
          bottom: window.pageYOffset + document.documentElement.clientHeight
        };

    if ((targetPosition.bottom + 200) > windowPosition.top &&
        (targetPosition.top + 200) < windowPosition.bottom ) {
      elemVisible = true
    } else {
      elemVisible = false
    }
    if(elemVisible) {
      target.classList.add('visible')
    }

  };

// Запускаем функцию при прокрутке страницы
  window.addEventListener('scroll', function() {
    Visible(karaoke);
    Visible(interactive);
    Visible(match)
    Visible(clicker)
    //up btn appear
    if($(window).scrollTop() > 800) {
      $('.up-btn').addClass('visible')
    } else {
      $('.up-btn').removeClass('visible')
    }
  });



  //banner animate
  if ($(window).width() >= 1000) {
    setTimeout(function () {
      $('.banner__animate').css('transition','1.1s')
      $('.banner').removeClass('animate-hidden')
      setTimeout(function () {
        $('.banner__animate').css('transition','.4s')
      }, 1200);
    }, 2000);
  }

  //smooth scrolling
  $(".menu a, .banner__button, .banner__down, .up-btn").on("click", function (event) {
    event.preventDefault();
    var id = $(this).attr('href'),
        top = $(id).offset().top;
    $('body,html').animate({scrollTop: top - 50}, 600);
  });

  //fixed menu
  var menu = $('#section1');
  var menuPosition;

  $(window).on('scroll', function () {
    var menuCoords = menu.offset();
    var windowScroll = $(this).scrollTop();

    if (!menuPosition) {
      menuPosition = menuCoords.top;
    }

    if (windowScroll > 0) {
      $('.header').addClass('scrolled')
    } else {
      menuPosition = false;
      $('.header').removeClass('scrolled')
    }

    if(windowScroll > 400) {
      $('.banner').addClass('animate-hidden')
      $('.banner__animate').css('transition','1.3s')
    } else {
      $('.banner').removeClass('animate-hidden')
      setTimeout(function () {
        $('.banner__animate').css('transition','.4s')
      }, 1200);
    }
  });

  //mobile menu
  $('.btn-menu').click(function () {
    $('.menu_header').toggleClass('active')
    $('.btn-menu').toggleClass('active')
    $('.menu__item a').click(function () {
      $('.menu_header').removeClass('active')
      $('.btn-menu').removeClass('active')
    })
  })

  if ($(window).width() <= 1000) {
    $('.banner').removeClass('animate-hidden')
  }

  if ($(window).width() <= 750) {
    var vacancySlider = tns({
      container: '.vacancy__slider',
      items: 1,
      controls: false,
      nav: true,
      mouseDrag: true,
      edgePadding: 100,
      fixedWidth: 290,
      speed: 500
    });
    $('.vacancy__item-wrap').on('click', function () {
      var info = vacancySlider.getInfo()
      var indexCurrent = info.index
      if($('.tns-slide-active').prev()[0] === $(this)[0]) {
        vacancySlider.goTo(indexCurrent - 1);
      } else {
        vacancySlider.goTo(indexCurrent + 1);
      }
    })
  }

  //languages
  $('.lang__item').click(function () {
    $('.lang__item').removeClass('lang__item_active');
    var lang = $(this).attr('class')
    // alert(lang)
    // $(this).addClass('lang__item_active');
    $('.lang__item').filter(function () {
      return $(this).attr("class") == lang
    }).addClass('lang__item_active')
    if ($('.lang__item_en').hasClass('lang__item_active')) {
      $('.en').css('display', 'block')
      $('.ru').css('display', 'none')
    }
    else if ($('.lang__item_ru').hasClass('lang__item_active')) {
      $('.ru').css('display', 'block')
      $('.en').css('display', 'none')
    }
  })


  //floating navigation

  $(function () {
    var $marker = $(".marker");
    var $upButton = $(".up");
    $(window).bind('scroll load', function () {
      var scroll_top = $(window).scrollTop();
      if ($(window).height() >= '900' || $(window).width() >= '700') {
        $upButton
            .stop()
            .animate({"marginTop": (scroll_top + 750) + "px"}, 500);
      }
      if ($(window).height() < '900') {
        $upButton
            .stop()
            .animate({"marginTop": (scroll_top + 600) + "px"}, 500);
      }
      if ($(window).height() < '700') {
        $upButton
            .stop()
            .animate({"marginTop": (scroll_top + 530) + "px"}, 500);
      }

      $('header').each(function () {
        if (scroll_top >= 800) {
          $upButton.addClass('active');
        } else {
          $upButton.removeClass('active');
        }
      })
    })

  })
})